import { FaQuoteLeft, FaQuoteRight } from 'react-icons/fa';




// import './App.css'; // Optional for your custom styles


export default function App() {
    

    return (
        <section className="timeline-wrapper section-padding">
            {/* <div className="container">
                <div className="row ">
                    <div className="col-12 col-lg-12">
                        <div className="section-title text-left">
                            <h2></h2>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="container">
                <p>
                    <strong>90+ Years of Quality, Innovation, and Trust</strong>
                    <br/>
                    Testfabrics, Inc. was founded in 1935 by Werner Klaas, a Swiss silk textile technologist who
                    immigrated to the United States during the Great Depression. With deep roots in the European
                    silk trade and New York’s textile district, Werner began by selling piece goods to dyers and lab
                    technicians—listening carefully as they described what they needed but couldn’t find.
                    <br/>
                    From those conversations came a radically simple yet enduring approach: <i>give people what
                    they ask for, prepare it to spec, and keep it in stock.</i>
                    <br/>
                    That approach led to the creation of the world’s first prepared-for-dyeing textile line, available in
                    flexible quantities and ready for immediate use in testing, formulation, and sampling. These
                    weren’t greige goods—they were properly desized, scoured, bleached or unbleached, and
                    mercerized when needed, designed to deliver consistent, clean surfaces for reliable lab work
                    and industrial performance.
                    <br/>
                    By the 1940s, Testfabrics had invented and become the global supplier of the multifiber test
                    fabric, a 6-fiber, 2x2 inch swatch used in standard colorfastness testing across the globe. We
                    are also the original source of the white cotton crockmeter square used in rubbing tests—two
                    innovations that remain industry benchmarks to this day.
                    <br/>
                    In 1972, Werner’s sons Finley Klaas and Tom Klaas officially joined the business, helping to
                    expand operations and deepen relationships with industry partners, research institutions, and
                    clients worldwide. Today, nearly a century later, Tom Klaas continues to lead as our senior
                    partner, working closely with the third generation—his children and Finley's—to carry the
                    family’s vision forward.
                    <br/>
                    As the decades progressed, our niche widened. From detergent giants and dye manufacturers
                    to textile chemists, museum conservators, university researchers, and even theater costume
                    designers - Testfabrics earned a reputation for being the “fabric store for specialists.” We
                    provided not just goods, but solutions.
                    <br/>
                    Need fabric cut to precise test sizes? Looking for a non-reactive textile for restoration work?
                    Sampling a new finish or dye formula? Our answer has always been the same: <i>What can we do
                    for you?</i>
                    <br/>
                    Today, we continue to stock and ship the largest range of test textiles and prepared-for-dyeing
                    materials in the world—serving clients from the Fortune 500 to boutique ateliers. Our
                    commitment to service, inventory, and quality has never wavered. We stand proudly in the
                    legacy of Werner Klaas and his philosophy of listening, solving, and adapting.
                    <br/>
                    <i>Testfabrics = Fabrics for Testing — and so much more.</i>
                    <br/>
                    <br/>
                </p>
                <div className='legacy-quote-container mb-3 d-flex justify-content-center align-items-center'>
                    <div className="quote-legacy">
                        <div id="quote-legacy-left">
                            <FaQuoteLeft size={30} style={{ verticalAlign: 'top' }} />
                        </div>
                        <strong><i>We listen. We adapt. We deliver. That’s how a Swiss silk merchant built a testing textile legacy—still family-run, nearly 100 years strong.</i></strong>
                        <div id='quote-legacy-right'>
                            <FaQuoteRight size={30} style={{ verticalAlign: 'bottom' }} />
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
}


